// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1WtWs","actionsCol":"EnrolledClinics_actionsCol__1vTHh"};